<template>
    <div>
        <footer>
            <div class="holder">
                <div class="wrap">
                    <div id="copyright">&copy; 2019</div>
                    <a href="#" id="logo-footer">
                      <img src="../assets/images/logo.png"
                          alt="Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
                          title="Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»">
                      <span>Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»</span></a>

                    <a v-bind:href="props.authorizedUser == null ? getEsiaUrl() : '/appeal'" class="btn-appeal btn"><span>Подать обращение</span></a>
                    <a href="/policy" id="policy">Политика обработки персональных данных</a>
                    <a href="#" id="browsers-support" v-on:click="$('#browsers-support')">Список поддерживаемых браузеров</a>
                </div>
            </div>
        </footer>

        <div class="modal-fadeout"></div>
        <div class="modal-wrapper" id="modal-geo">
            <div class="modal">
                <div class="contents">
                    <div class="modal-close" title="Close"></div>

                    <h1>Выбрать муниципальное образование</h1>

                    <select id="mun_select" name="geo">
                        <option v-for="municipality in props.municipalities" v-if="municipality.id != constants.MUNICIPALITIES.ALL"
                                v-bind:value="municipality.id"
                                v-bind:name="municipality.name"
                                v-bind:selected="municipality.id == props.municipalityId"
                        >{{ municipality.name }}</option>
                    </select>
                    <button class="btn type2" v-on:click="saveMunicipality()">Сохранить</button>
                </div>
            </div>
        </div>

        <div class="modal-wrapper" id="modal-browsers-support">
            <div class="modal">
                <div class="contents">
                    <div class="modal-close" title="Close"></div>

                    <h1>Список поддерживаемых браузеров</h1>

                    <ul>
                        <li>Microsoft Edge / Internet Explorer 10 и выше</li>
                        <li>Mozilla Firefox 60 и выше</li>
                        <li>Google Chrome 49 и выше</li>
                        <li>Opera 35 и выше</li>
                        <li>iOS Safari 12 и выше</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import PageScripts from "../assets/js/page-scripts";
    import Application from "../application";

    export default {
        data: function () {
            return {
                props: Application.props,
                constants: Application.constants,
                newMunicipalityId: null,
                providers: UserAPI.authProviders(),
            }
        },
        created: function () {

        },

        mounted: function() {
            let that = this;
            this.newMunicipalityId = $("#mun_select").val();
            setTimeout(function() {
                $("#mun_select").selectmenu({ change: function (event, ui) {
                    that.newMunicipalityId = ui.item.value;
                }});
            }, 100);
        },

        methods: {
            saveMunicipality: function () {
                localStorage.setItem(Application.constants.LOCAL_STORAGE_MUNICIPALITY_ID, this.newMunicipalityId);
                Application.setCurrentMunicipalityName();
                PageScripts.hideModal();
                location.reload();
            },
            getEsiaUrl: function () {
                for (let i = 0; i < this.providers.length; i++) {
                    let provider = this.providers[i];
                    if (provider.name == 'esia') {
                        return provider.url;
                    }
                }
                return "";
            },
        }
    }
</script>


// WEBPACK FOOTER //
// VFooter.vue?4a3947ef